export const linkablePages = [
  "page",
  "landingPage",
  "ship",
  "destination",
  "exclusiveOfferPerPromo"
];

export const linkablePageTypes = linkablePages.map((l) => ({ type: l }));
